/*
  BNH — Sağ alt köşedeki yüzen öğelerin çakışmasını önler.

  WhatsApp balonu <gty-whatsapp-chat-button> içinde, bir shadow root'un
  içinde duruyor ve `bottom: 73px` sabit yazılmış. Sayfa CSS'i shadow
  root'a giremediği için konumu buradan, JS ile ayarlıyoruz.

  Balonun altında kalabilecek şeyler:
    - mobil alt dock (.mobile-dock)
    - ürün sayfasındaki yapışkan sepet çubuğu (.product-sticky-cart)

  Sınıf/öznitelik yerine GERÇEK GEOMETRİ ölçüyoruz: ekranın altına
  yapışmış, görünür durumdaki her çubuğun en üst noktasını buluyoruz.
*/
(function () {
  var GAP = 16;
  var BARS = ['.product-sticky-cart', '.mobile-dock', '.sticky-atc', '.bnh-sticky-bar'];
  var host, wrapper;

  function findWrapper() {
    if (wrapper && wrapper.isConnected) return wrapper;
    host = document.querySelector('gty-whatsapp-chat-button');
    if (!host || !host.shadowRoot) return null;
    wrapper = host.shadowRoot.querySelector('.gty-wacb-wrapper');
    return wrapper;
  }

  /* Ekranın altını kaplayan görünür çubukların en üst noktası. */
  function occupiedHeight() {
    var vh = window.innerHeight;
    var topMost = vh;

    for (var i = 0; i < BARS.length; i++) {
      var nodes = document.querySelectorAll(BARS[i]);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') continue;
        if (parseFloat(cs.opacity) < 0.15) continue;
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;

        var r = el.getBoundingClientRect();
        if (r.height < 8 || r.width < 40) continue;
        /* Alt kenara yapışık mı ve ekranın içinde mi? */
        if (r.bottom < vh - 4 || r.top > vh - 8) continue;
        /* Sağ alt köşeyi gerçekten kaplıyor mu? */
        if (r.right < window.innerWidth - 80) continue;

        if (r.top < topMost) topMost = r.top;
      }
    }
    return Math.max(0, vh - topMost);
  }

  function place() {
    var w = findWrapper();
    if (!w) return;
    var bottom = Math.round(occupiedHeight()) + GAP;
    if (w.dataset.nbBottom === String(bottom)) return;
    w.dataset.nbBottom = String(bottom);
    w.style.setProperty('bottom', bottom + 'px', 'important');
    w.style.setProperty('z-index', '90', 'important');
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; place(); });
  }

  /* Çubuk animasyonla açılıp kapandığı için birkaç kare boyunca izle. */
  var settleTimer = null;
  function settle() {
    schedule();
    if (settleTimer) clearInterval(settleTimer);
    var n = 0;
    settleTimer = setInterval(function () {
      place();
      if (++n > 12) { clearInterval(settleTimer); settleTimer = null; }
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', settle);
  } else {
    settle();
  }
  window.addEventListener('load', settle);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', settle, { passive: true });
  document.addEventListener('cartdrawer:opened', settle);
  document.addEventListener('cartdrawer:closed', settle);
  document.addEventListener('transitionend', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('product-sticky-cart')) settle();
  }, true);

  /* Çubuklar `animate` özniteliğiyle açılıyor; anında yakala. */
  function watchBars() {
    var targets = document.querySelectorAll('animate-sticky, .mobile-dock, .product-sticky-cart');
    if (!targets.length) return false;
    var mo = new MutationObserver(settle);
    for (var i = 0; i < targets.length; i++) {
      mo.observe(targets[i], { attributes: true, attributeFilter: ['class', 'animate', 'style'] });
    }
    return true;
  }

  /* Widget ve çubuklar geç mount oluyor; kısa süre dene. */
  var tries = 0;
  var barsWatched = false;
  var t = setInterval(function () {
    place();
    if (!barsWatched) barsWatched = watchBars();
    if (++tries > 30 || (wrapper && wrapper.isConnected && barsWatched)) clearInterval(t);
  }, 400);
})();
